<template>
    <div>
        <van-tabs
            v-model:active="active"
            color="#65A4F9"
        >
            <!-- 综合的数据 -->
            <van-tab title="综合" name="MIX">
                <van-list
                    v-model:loading="mixLoading"
                    :finished="mixFinished"
                    finished-text="没有更多了"
                    @load="loadSearchMix"
                >
                    <!-- TODO -->
                    <mix-list :loading="mixLoading" :result="mixResult"/>
                </van-list>
            </van-tab>
            <!-- 其他数据 -->
            <van-tab
                v-for="item in tabs"
                :key="item.type"
                :title="item.title"
                :name="item.type"
            >
                <van-list
                    v-model:loading="resultList[item.type].loading"
                    :finished="resultList[item.type].finished"
                    finished-text="没有更多了"
                    @load="loadResource"
                >
                    <resource-list
                        :loading="resultList[item.type].loading"
                        :coverType="resultList[item.type].coverType"
                        :list="resultList[item.type].list"
                    />
                </van-list>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import ResourceList from '@/components/resourceList'

import MixList from '../mixList'
import {search, searchMix} from "@/api/CommonApi";
import {calcVideo,calcHtml,calcBook} from "@/views/personage/CalcResourceHorList";
// import { watch } from '@vue/runtime-core'

function getDefaultMixResult(){
    return {
        celebrity:[],// 历史名人
        resources:{ // 资源，综合内容
            current:0,
            pages:1,
            records:[],// 结果
        }
    }
}


export default {
    name: 'Result',
    components: {
        ResourceList,
        MixList
    },
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        keyword: {
            type: String,
            default: () => ''
        }
    },
    setup() {
        return {
            active:ref('MIX'),
            resultList:ref({}),
            // 综合的搜索结果 START
            mixResult: ref(getDefaultMixResult()), // 综合搜索的结果 END
            mixLoading:ref(false), // 综合搜索是否加载中
            mixFinished:ref(false),// 综合搜索是否完全搜索结束
        }
    },
    created() {
        this.init()
    },
    methods:{
        /**
         * 初始化
         * 此函数用来重置搜索结果的，请勿编写请求接口的代码
         * 父组件在侦听“关键词”变化后将调用此函数来重置搜索结果，
         * 以此触发重新请求搜索结果数据
         */
        init(){
            this.active = 'MIX'
            this.mixResult = getDefaultMixResult()
            this.mixLoading = false
            this.mixFinished = false

            for(let item of this.tabs) {
                let coverType = ''
                switch(item.type) {
                    case 'HTML':coverType = 'story';break;
                    case 'VIDEO':coverType = 'video';break;
                    case 'PDF':coverType = 'book';break;
                }

                this.resultList[item.type] = {
                    title: item.title,
                    list: [],
                    page: 0,
                    coverType: coverType,
                    loading: false,
                    finished: false,
                }
            }
        },
        /**
         * 加载 综合 的搜索结果
         */
        loadSearchMix(){
            // 搜索结束 return
            if(this.mixFinished) return;
            const params = {
                keyword:this.keyword,
                page:this.mixResult.resources.current + 1,
            }
            searchMix(params).then(res => {
                const result = res.result
                // 如果是第一页,设置历史名人信息
                if(params.page === 1){
                    this.mixResult.celebrity = result.celebrity || [];
                }
                // 复制分页数据
                const pageData = result.resources || null
                if(!pageData){
                    this.mixFinished = true
                    return;
                }
                const resources = this.mixResult.resources
                // 判断搜索是否结束
                this.mixFinished = pageData.current >= pageData.pages
                resources.current = pageData.current
                resources.pages = pageData.pages
                resources.records = [
                    ...resources.records,
                    ...pageData.records
                ]
            }).finally(() => {
                this.mixLoading = false
            })
        },
        /**
         * 加载 PDF，视频，音乐 的搜索结果
         */
        loadResource(){
            // 当前激活的标签页
            const activeKey = this.active
            const listBody = this.resultList[activeKey]
            const page = listBody.page

            listBody.loading = true
            // 如果加载完毕，return
            if(listBody.finished) return;

            const params = {
                keyword: this.keyword,
                page: page + 1,
                resourceType: activeKey,
                searchTopic:false,
            }
            search(params).then(res => {
                const result = res.result.resource
                // 合并结果集
                const list = [...listBody.list,...result.records]
                // 计算path
                switch(activeKey) {
                    case 'HTML':listBody.list = calcHtml(list);break;
                    case 'VIDEO':listBody.list = calcVideo(list);break;
                    case 'PDF':listBody.list = calcBook(list);break;
                }
                listBody.page = result.current
                listBody.finished = result.current >= result.pages
            }).finally(() => {
                listBody.loading = false
            })
        }
    }
}
</script>

<style scoped>
.loading {
    text-align: center;
    margin-top: 20px;
}
</style>

